import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { UserToken } from '../models/user-token.model';
import { ResponseUtil } from '../../shared/utils/response-util';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { MultiAgency } from 'app/shared/models/multi-agency';
import { CustomerConfig } from 'app/auth/models/Customer-config';
import { UserJti } from '../models/user-jti.model';

@Injectable()
export class AuthenticationHttpService {
  private readonly loginURL: string = this.environment.baseUrl + '/api/auth/login';
  private readonly permissionURL: string = this.environment.baseUrl + '/api/auth/permissions';
  private readonly jtiURL: string = this.environment.baseUrl + '/api/auth/username';
  private readonly refreshURL: string = this.environment.baseUrl + '/api/auth/refresh';
  private readonly updateIataURL: string = this.environment.baseUrl + '/api/auth/update/iata';
  private readonly clientContactEditableURL: string = this.environment.baseUrl + '/api/auth/customer/edit';

  constructor(private http: HttpClient,
              private environment: EnvironmentConfiguration) {
  }

  login(username: string, password: string): Observable<UserToken> {
    const loginPayload = { 'userId': username, 'password': password };

    return this.http.post(this.loginURL, loginPayload)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  getPermissions(token: string, defaultArciata: string): Observable<UserToken> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token,
    });

    let options = null;

    if (defaultArciata == null || defaultArciata.length === 0) {
      options = {
        headers: headers
      }; // Create a request option
    } else {
      options = {
        headers: headers,
        params: new HttpParams().set('arcIata', defaultArciata)
      }; // Create a request option
    }

    return this.http.get(this.permissionURL, options)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  getJti(token: string): Observable<UserJti> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token,
    });
    let options = null;
    options = {
      headers: headers
    }; // Create a request option
    return this.http.get(this.jtiURL, options)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  refreshPermissions(token: string): Observable<UserToken> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token,
    });

    const options = {
      headers: headers
    }; // Create a request option

    return this.http.get(this.refreshURL, options)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  updateIataFromToken(token: string, newArciata: string): Observable<UserToken> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token,
    });

    let options = {
      headers: headers,
      params: new HttpParams().set('arcIata', newArciata)
    }; // Create a request option

    return this.http.get(this.updateIataURL, options)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  retrieveAgencies(token: string): Observable<MultiAgency[]> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token,
    });

    let options = {
      headers: headers
    }; // Create a request option

    return this.http.get(this.environment.baseUrl + '/api/lookup/agencies/token', options)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  isClientContactEditable(token: string): Observable<CustomerConfig> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': token,
    });

    let options = {
      headers: headers
    }; // Create a request option

    return this.http.get(this.clientContactEditableURL, options)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/permission/services/authentication.http.service.ts